import { ScrollArea } from "alm-react-components";
import { useContext, useEffect, useLayoutEffect, useState } from "react";
import { WeekDetailType } from "../../../../interface";
import { Lession } from "./Lession";
import getLocalizedContent from "../../../../lib/getLocalizedMetaData";
import { appcues_event } from "../../../../assets/constants/staticContentConstants";
import { AppContext } from "../../../../context/AppProvider";
import { fetchAppcuesEvents } from "../../../../services/appcuesData";
import { AppcuesConstant } from "../../../../assets/constants/constants";
import { putAppCuesData } from "../../../../lib/appcues";

export const WeekDetail = ({
  weekResponse,
  courseList,
  courseUpdate,
  courseId,
  weekId,
  completedCourses,
}: WeekDetailType) => {
  const { state } = useContext(AppContext);
  const [isAlreadyTracked, setIsAlreadyTracked] = useState(true)
  useLayoutEffect(() => {
    const element = document.getElementById(`box-${courseId}`) as HTMLElement;
    element.scrollIntoView();
    element.scrollIntoView(false);
    element.scrollIntoView({ block: 'end' });
    element.scrollIntoView({ behavior: 'smooth', block: 'end', inline: 'nearest' });
  }, []);
  const doUpdate = (
    cardSelected: string | null,
    course: any,
    sequence: any
  ) => {
    if (!cardSelected) courseUpdate(course?.id, sequence);
  };
  const allMandatoryCompleted = courseList?.filter((item: any) => item?.mandatory && completedCourses.includes(item.id)).length;
  const allMandatorylength = courseList?.filter((item: any) => item?.mandatory).length
  useEffect(() => {
    if (completedCourses?.length > 0) {
      if (allMandatoryCompleted !== allMandatorylength) return;
      if (allMandatoryCompleted == allMandatorylength) {
        const user_Id = state.user?.email || "";
        fetchAppcuesEvents(user_Id)
        .then((events: any[]) => {
          if (events && !Array.isArray(events)) return;
          const alreadyTracked:any = events.some(
            (event) =>{
              return (
                event.name.split('_')[0] === AppcuesConstant.weekComplete &&
                event.attributes?._identity?.week_number === parseInt(weekId) + 1
              )
          }
        );
            if (alreadyTracked) {
              return
            }
            setIsAlreadyTracked(alreadyTracked)
          })
          .catch((error) => {
            console.error("Appcues fetch failed:", error);
          });
      }
    }

  }, [allMandatoryCompleted, allMandatorylength, completedCourses]);

  useEffect(() => {
    const user_Id = state.user?.email || "";
   
    if (!isAlreadyTracked) {  
      putAppCuesData({
        event_Name: appcues_event.weekComplete,
        eventName: `${appcues_event.weekComplete}_${weekResponse?.id}_${getLocalizedContent(weekResponse?.attributes)?.name}`,
        userId: user_Id,
        program_id: weekResponse?.id,
        program_name: getLocalizedContent(weekResponse?.attributes?.localizedMetadata)?.name,
        week_number: parseInt(weekId) + 1,
        week_name: getLocalizedContent(weekResponse?.attributes?.localizedMetadata)?.name
      });
    }

  }, [isAlreadyTracked])
  return (
    <>
      {courseId && (
        <div className="">
          <h4 className="font-light tracking-wider text-base font-barlowLight p-2 pb-3">
            {getLocalizedContent(weekResponse?.attributes?.localizedMetadata).name}
          </h4>
          <ScrollArea className="class-list-item-scroller">
            {courseList.length > 0 &&
              courseList?.map((course: any, index: number) => {
                const cardSelected = courseId == course.id ? 'card-selected' : null;
                const sequence = `${weekId}${index}`
                return (
                  <div key={course.id}
                    onClick={() => doUpdate(cardSelected, course, sequence)}
                    id={`box-${course.id}`}
                    className={`flex my-1 p-2 rounded-xl relative dark:text-gray-300 dark:hover:bg-fillMidGrayCard cursor-pointer dark:hover:text-white hover:bg-transparent   ${cardSelected}`}
                  >
                    <Lession course={course} index={index} />
                  </div>
                );
              })}
          </ScrollArea>
        </div>
      )}
    </>
  );
};
